import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/home/multi-repos/proz-next/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/multi-repos/proz-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/multi-repos/proz-next/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent","TooltipArrow"] */ "/home/multi-repos/proz-next/src/components/shadcn/tooltip.tsx");
